import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastService } from '../../../services/toast-service';
import { CalibrantLoadModule } from '../../shared/calibrant-load/calibrant-load.module';
import { SiteFinancialComponent } from "./site-financial.component";
import { TariffsComponent } from "./tariffs/tariffs.component";
import { SiteUtilitiesComponent } from "./utilities/site-utilities.component";
import { SiteProgramsComponent } from "./site-programs/site-programs.component";
import { ChargesComponent } from "./charges/charges.component";
import {
  MatAccordion,
  MatExpansionModule,
} from '@angular/material/expansion';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';


@NgModule({ declarations: [
        SiteFinancialComponent,
        TariffsComponent,
        SiteUtilitiesComponent,
        SiteProgramsComponent,
        ChargesComponent,
    ],
    exports: [
        SiteFinancialComponent
    ], imports: [CommonModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    CalibrantLoadModule, MatExpansionModule, MatButton, MatIcon, MatTooltip, MatAccordion, MatFormField, MatSelect, MatOption, MatInput, MatCheckbox, MatLabel, MatDialogActions, MatDialogTitle, MatDialogContent], providers: [
        ToastService,
        provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_DIALOG_DATA, useValue: {} }
    ] })
export class SiteFinancialModule { }
